import { render, staticRenderFns } from "./SIS_ProgrammeEdit.vue?vue&type=template&id=55bc2539&"
import script from "./SIS_ProgrammeEdit.vue?vue&type=script&lang=ts&"
export * from "./SIS_ProgrammeEdit.vue?vue&type=script&lang=ts&"
import style0 from "./SIS_ProgrammeEdit.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports